module.exports = __webpack_public_path__ + "static/media/zhongniuhushan1.f824d807.webp";